import {
    ComponentObject,
    ComponentSelectors,
    ComponentElements,
    ComponentService,
    ComponentInjector,
    ComponentSelector,
    UIComponent
} from '@atypon/ui-utils';

class Texts extends ComponentObject { }

class ClassList extends ComponentObject {
    a2aLabel = 'a2a-label';
}

class Selectors extends ComponentSelectors {
    addToAnyLinks = new ComponentSelector('a');
}

class Elements extends ComponentElements<Selectors> {
    addToAnyLinks: Array<HTMLElement> = [];
}

interface AddToAnyEnhancement extends ComponentService<Selectors, Elements, ClassList, Texts> { }

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class AddToAnyEnhancement implements UIComponent {
    constructor(readonly wrapper: HTMLElement) { }

    initialize(): void {
        this.elements.initialize(this.wrapper);
        this.replaceTitleWithAriaLabel();
        this.addEventListeners();
    }

    addEventListeners(): void { }

    private replaceTitleWithAriaLabel() {
        this.elements.addToAnyLinks.forEach((el) => {
            var text = el.getAttribute('title');
            el.removeAttribute('title');
            el.setAttribute('aria-label', text);
        })
    }
}

export default AddToAnyEnhancement;

export {
    Elements as AddToAnyEnhancementElements,
    Selectors as AddToAnyEnhancementSelectors,
    ClassList as AddToAnyEnhancementClassList,
    Texts as AddToAnyEnhancementTexts,
}
